export const EVENT_TYPE = 'half height banner';


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/analytics/constants.js
 **/